<template>
  <div class="max-w-full lg:max-w-3xl mx-auto px-12 lg:px-0">
    <div class="text-2xl font-light text-gray-800">
      Ideally, how much do you want to borrow?
    </div>

    <div class="mt-4 relative">
      <div class="absolute text-sm ml-3 text-gray-600" style="margin-top:11px;">
        $
      </div>
      <input type="text" class="input-standard pl-6" v-model="borrowAmount" ref="borrow" v-on:keyup="inputTextTyped($event.target.value, 'borrowAmount')" />
    </div>

    <div class="mt-2 text-red-500 text-base" v-if="borrowAmountError != null">
      {{ borrowAmountError }}
    </div>





    <template v-if="lead.primarReason !== null && (lead.primaryReason == 0 || lead.primaryReason === 3 || lead.primaryReason === 5 || lead.primaryReason === 7)">
      <div class="text-2xl font-light text-gray-800 mt-12">
        How much do you wish to spend on the property?
      </div>

      <div class="mt-2 relative">
        <div class="absolute text-sm ml-3 text-gray-600" style="margin-top:11px;">
          $
        </div>
        <input type="text" class="input-standard pl-6" v-model="spendAmount" ref="spend" v-on:keyup="inputTextTyped($event.target.value, 'spendAmount')" />
      </div>

      <div class="text-2xl font-light text-gray-800 mt-12">
        Do you have funds for the deposit?
      </div>
      
      <div class="flex items-center mt-4">
        <input type="radio" name="input-has-fund" v-model="hasFund" value="1" id="input-has-fund-yes" />
        <label for="input-has-fund-yes" class="mr-8 text-base ml-2">Yes</label>

        <input type="radio" name="input-has-fund" v-model="hasFund" value="0" id="input-has-fund-no" />
        <label for="input-has-fund-no" class="text-base ml-2">No</label>
      </div>

      <template v-if="hasFund == 1">
        <div class="text-2xl font-light text-gray-800 mt-12">
          How much do you have available for a deposit?
        </div>

        <div class="mt-1 text-base text-gray-800">
          We have borrowing strategies even for small deposits.
        </div>

        <div class="mt-2 relative">
          <div class="absolute text-sm ml-3 text-gray-600" style="margin-top:11px;">
            $
          </div>
          <input type="text" class="input-standard pl-6" v-model="deposit" ref="deposit" v-on:keyup="inputTextTyped($event.target.value, 'deposit')" />
        </div>
      </template>
    </template>



    <template v-if="lead.primarReason !== null && (lead.primaryReason == 1 || lead.primaryReason === 2 || lead.primaryReason === 4)">
      <div class="text-2xl font-light text-gray-800 mt-12">
        What property will you use as security for the loan?
      </div>

      <div class="mt-2 flex items-center">
        <input type="radio" name="input-security" v-model="security" value="1" id="input-security-broker" />
        <label for="input-security-broker" class="ml-2 text-base">Discuss with broker</label>
      </div>

      <div class="mt-2 flex items-center">
        <input type="radio" name="input-security" v-model="security" value="2" id="input-security-own" />
        <label for="input-security-own" class="ml-2 text-base">Own home</label>
      </div>

      <div class="mt-2 flex items-center">
        <input type="radio" name="input-security" v-model="security" value="3" id="input-security-investment" />
        <label for="input-security-investment" class="ml-2 text-base">Investment property</label>
      </div>

      <template v-if="security == 2 || security == 3">
        <div class="text-2xl font-light text-gray-800 mt-12">
          Approximate value
        </div>

        <div class="mt-2 relative">
          <div class="absolute text-sm ml-3 text-gray-600" style="margin-top:11px;">
            $
          </div>
          <input type="text" class="input-standard pl-6" v-model="securityValue" ref="securityValue" v-on:keyup="inputTextTyped($event.target.value, 'securityValue')" />
        </div>
      </template>
    </template>





    <div class="mt-12">
      <a href="#" @click.prevent="next"
        :class="{ 
          'text-white py-4 rounded text-sm uppercase font-semibold inline-block px-16 overflow-hidden' : true, 
          'bg-blue-500 hover:bg-blue-600' : canGoNext(), 
          'bg-gray-500 hover:bg-gray-600' : !canGoNext() }">
        <div class="float-left">Submit</div>

        <svg width="22" height="22" stroke-width="2" class="ml-4 float-left" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#chevron-right"/>
        </svg>
      </a>
    </div>

    <div class="mt-4 ml-2">
      <a href="#" @click.prevent="back()"
        class="text-gray-500 hover:underline">Go back</a>
    </div>
	</div>
</template>

<script>
  export default {

    mounted() {
      this.$refs.borrow.focus()
    },

    data() {
      return {
        borrowAmount : null,
        spendAmount  : null,
        hasFund      : 1,
        deposit      : null,
        security     : 1,
        securityValue: null,

        lead: null,
        
        borrowAmountError: null,
        spendAmountError : null,

        
      }
    },

    created() {
      if(this.$route.params.data != null) {
        this.lead = JSON.parse(decodeURIComponent(this.$route.params.data))
      } else {
        this.lead = {}
      }

      if(this.lead.hasFund != null) {
        this.hasFund = this.lead.hasFund
      }

      if(this.lead.deposit != null) {
        this.deposit = this.lead.deposit
      }

      if(this.lead.security != null) {
        this.security = this.lead.security
      }

      if(this.lead.securityValue != null) {
        this.securityValue = this.lead.securityValue
      }
    },

  	methods : {

      inputTextTyped(value, type) {
        this[type] = this.addCommaToNumber(value)
      },

      canGoNext() {
        return this.borrowAmount != null
      },

      back() {
        this.$router.push({
          name  : 'client-lead-capture-contact',
          params: {
            data : this.$route.params.data != null ? this.$route.params.data : null
          }
        })
      },

      next() {
        let valid = true

        this.borrowAmountError = null
        this.spendAmountError  = null
        
        if(this.borrowAmount == null) {
          this.borrowAmountError = "Please type a valid amount."
          valid = false
        }

        if(valid) {

          this.lead.borrowAmount  = this.borrowAmount
          this.lead.spendAmount   = this.spendAmount
          this.lead.hasFund       = this.hasFund
          this.lead.deposit       = this.deposit
          this.lead.security      = this.security
          this.lead.securityValue = this.securityValue

          // this.$router.push({
          //   name  : 'client-lead-capture-credit-history',
          //   params: {
          //     data : encodeURIComponent(JSON.stringify(this.lead))
          //   }
          // })

          this.apiPost({
            brokerId: this.$route.params.brokerId,
            lead    : this.lead
          }, 'lead-capture/lead', (data) => {

            // request to process the data and redirect the user
            this.apiPost({
              leadCaptureId : data.id
            }, 'lead-capture/process', () => {

            })

            this.$router.push({
              name: 'client-lead-capture-submitted'
            })
          })
        }
      }
  	}
  }
</script>